import { styled } from '@mui/material/styles'
import { Box, Button, Typography } from '@mui/material'
import { MuiButton } from '../../../../../components'

export const Wrapper = styled(Box)(`
  width:50vw;
  min-width:370px;
`)

export const ContentWrapper = styled(Box)(`
  max-height : calc(700px - 62px - 35px);
  overflow-y : auto;
`)

export const Title = styled(Typography)(`
  margin-top: -10px;
  padding-bottom: 30px;
  font-style: normal;
  font-weight: 400; // 300;
  font-size: 20px;
  line-height: 30px;
  text-transform: capitalize;
`)

export const SubTitle = styled(Typography)(`
  margin-top: 16px;
  margin-bottom: 12px;
  padding-bottom: 0;
  font-style: normal;
  font-weight: 600; // 500;
  font-size: 14px;
  line-height: 21px;
  width:100%;
`)

export const CheckboxWrapper = styled(Box)(`
  & > label {
    width: 25%;
    margin-left: -5px;
    margin-right: 5px;
    margin-bottom: 16px;

    &.themeV2 {
      display : inline-flex;
    }
  }
`)

export const DropdownWrapper = styled(Box)(`
  display: flex;
  flex-flow: wrap;
  & > p {
    width: 100%;
    padding-bottom:5px;
  }
  & .selectWrap {
    width: 220px;
  }
  & > label {
    width: 100px;
    margin-left: 20px;
    padding: 0;
  }
`)

export const ColumnWidthWrapper = styled(Box)(`
    display: flex;
    width: 100%;
    flex-wrap: wrap;
    gap : 7px;

  & .TextFieldWrapper {
    width: 120px;
  }
`)

export const EqualWidthWrapper = styled(Box)(`
    display : flex;
    align-items : center;
    margin-top : 16px;
    gap : 8px;
  `)

export const EqualWidth = styled(Button)(`
  font-size: 12px;
  border-radius: 20px;
  height: 24px;
  display: flex;
  align-items: center;
  // gap: 5px;
  border : 1px solid;
  padding : 0;
  // marginRight: 18px;
  // &:hover {
  // },
`)

export const EqualWidthText = styled('span')(`
  font-size : 14px;
`)

export const ErrorWrapper = styled('span')(`
  font-size : 14px;
  font-weight: 400; 
  color: #EE2534; 
`)

export const ConfigureTableButtonWrapper = styled(Box)(`
  display : flex;
  justify-content : space-between;
  margin-top : 30px;
`)

export const ColumnWidth = styled(Box)(`
  display : flex;
  justify-content : space-between;
  flex-direction : column;
  gap: 4px;
`)

export const ColumnWidthTitle = styled('span')(`
  font-size: 12px;
  font-weight: 600;
  color: #686867;

  & .required {
    color : #EE2534;
  }
`)